import React, { useState } from "react";
import { ErrorDialog } from "src/components/common/dialogs/errorDialog/ErrorDialog.tsx";
import { AnyError } from "src/errorHandling/anyError.ts";


export type ShowErrorDialogFunc = (e: AnyError) => void
export const ErrorDialogContext = React.createContext<ShowErrorDialogFunc | undefined>(
	undefined
);

export interface ErrorDialogProviderProps extends React.PropsWithChildren {
}

export const ErrorDialogProvider = ({ children }: ErrorDialogProviderProps) => {
	const [error, setError] = useState<AnyError | undefined>(undefined);
	return <>
		<ErrorDialogContext.Provider value={setError}>
			{children}
		</ErrorDialogContext.Provider>
		<ErrorDialog
			size={"sm"}
			onClose={() => {
				setError(undefined);
			}}
			error={error}
		/>
	</>;
};